"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ficoArray", {
  enumerable: true,
  get: function get() {
    return _creditScore.ficoArray;
  }
});
Object.defineProperty(exports, "calculateBucket", {
  enumerable: true,
  get: function get() {
    return _approvalOdds.calculateBucket;
  }
});
Object.defineProperty(exports, "approvalOddsPopoverContent", {
  enumerable: true,
  get: function get() {
    return _approvalOdds.approvalOddsPopoverContent;
  }
});
Object.defineProperty(exports, "getColorAndLabel", {
  enumerable: true,
  get: function get() {
    return _approvalOdds.getColorAndLabel;
  }
});
Object.defineProperty(exports, "Heading", {
  enumerable: true,
  get: function get() {
    return _heading.default;
  }
});
Object.defineProperty(exports, "getCreditScoreComparisonContent", {
  enumerable: true,
  get: function get() {
    return _heading.getCreditScoreComparisonContent;
  }
});
Object.defineProperty(exports, "recommendedCreditScorePopoverContent", {
  enumerable: true,
  get: function get() {
    return _heading.recommendedCreditScorePopoverContent;
  }
});
exports.default = exports.transunionLogoCta = exports.getColor = exports.CREDIT_DASHBOARD_PATH_WITH_TRK = exports.CREDIT_DASHBOARD_PATH = exports.LOA_COLORS = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _isNumber2 = _interopRequireDefault(require("lodash/isNumber"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _creditScore = require("@nerdwallet/nw-client-lib/credit-score");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTypography = _interopRequireDefault(require("@nerdwallet/react-typography"));

var _Right = _interopRequireDefault(require("@nerdwallet/react-icon/gizmo/Right"));

var _reactLink = _interopRequireDefault(require("@nerdwallet/react-link"));

var _variables = require("@nerdwallet/base-styles/variables");

var _nwClientLib = require("@nerdwallet/nw-client-lib");

var _trkHelper = require("@nerdwallet/nw-client-lib/trk-helper");

var _approvalOdds = _interopRequireWildcard(require("./approval-odds"));

var _heading = _interopRequireWildcard(require("./heading"));

var _utils = _interopRequireDefault(require("./utils"));

var _propTypes2 = require("./prop-types");

var _likelihoodOfApprovalModule = _interopRequireDefault(require("../likelihood-of-approval.module.less"));

var _params;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LAYOUT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
var LOA_COLORS = {
  TEXT_DEFAULT: _variables.colors['neutral-dark'],
  BAR_DEFAULT: _variables.colors['blue-dark'],
  BAR_ABOVE: _variables.colors.yellow,
  BAR_WITHIN: _variables.colors['green-dark'],
  BAR_BELOW: _variables.colors['red-light']
};
exports.LOA_COLORS = LOA_COLORS;
var CREDIT_DASHBOARD_PATH = '/home/dashboard/credit-score';
exports.CREDIT_DASHBOARD_PATH = CREDIT_DASHBOARD_PATH;
var CREDIT_DASHBOARD_PATH_WITH_TRK = (0, _trkHelper.setTrk)({
  url: CREDIT_DASHBOARD_PATH,
  params: (_params = {}, _defineProperty(_params, _trkHelper.TrkTag.element, _trkHelper.TrkElement.hyperlink), _defineProperty(_params, _trkHelper.TrkTag.location, 'likelihood_of_approval'), _params)
}); // Returns color of bar and labels

exports.CREDIT_DASHBOARD_PATH_WITH_TRK = CREDIT_DASHBOARD_PATH_WITH_TRK;

var _getColor = function getColor(minCreditScoreValue, maxCreditScoreValue, creditScore) {
  if (!creditScore) {
    return LOA_COLORS.BAR_DEFAULT;
  } else if (creditScore > maxCreditScoreValue) {
    return LOA_COLORS.BAR_ABOVE;
  } else if (creditScore >= minCreditScoreValue) {
    return LOA_COLORS.BAR_WITHIN;
  }

  return LOA_COLORS.BAR_BELOW;
};
/**
 * Returns the transunion logo.
 */


exports.getColor = _getColor;

var transunionLogoCta = function transunionLogoCta() {
  return _react.default.createElement("a", {
    href: CREDIT_DASHBOARD_PATH_WITH_TRK,
    target: "_",
    className: (0, _classes.default)('display-block')
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)('tu-logo', _likelihoodOfApprovalModule.default.tuLogo)
  }));
};

exports.transunionLogoCta = transunionLogoCta;
var CCElementImpression = _nwClientLib.Tracking.CCElementImpressionConnect;
var CCElementInteraction = _nwClientLib.Tracking.CCElementInteractionConnect;
var colorsArray = Object.keys(_variables.colors);

var LikelihoodOfApproval =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LikelihoodOfApproval, _React$Component);

  // Since ficoArray is used in an enum prop-type validator export it from
  // this file so `react-docgen` documentation can be properly generated
  // exported for docgen to validate proptypes
  function LikelihoodOfApproval(props) {
    var _this;

    _classCallCheck(this, LikelihoodOfApproval);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LikelihoodOfApproval).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "calculateCreditScorePosition", function (min, max, index) {
      var pos = index / _creditScore.ficoArray.length * 100 + (_this.props.creditScore - min) / (max - min) * 25; // Set 97% as the max for stylistic reasons -- setting to 100%
      // means the marker looks halfway off the bar

      if (pos > 97) {
        pos = 97;
      } else if (pos < 0) {
        pos = 0;
      }

      return "".concat(pos, "%");
    });

    _defineProperty(_assertThisInitialized(_this), "renderLabel", function () {
      var _this$props = _this.props,
          minCreditScoreRange = _this$props.minCreditScoreRange,
          maxCreditScoreRange = _this$props.maxCreditScoreRange; // If the label spans more than one range, display both

      var label = _this.maxCreditScoreIndex > _this.minCreditScoreIndex ? "".concat(minCreditScoreRange, " - ").concat(maxCreditScoreRange) : minCreditScoreRange;
      return _react.default.createElement(_reactTypography.default, {
        className: (0, _classnames.default)('label-range', _likelihoodOfApprovalModule.default.label, _likelihoodOfApprovalModule.default.labelRange),
        inline: true
      }, label);
    });

    _defineProperty(_assertThisInitialized(_this), "getApprovalBarWidth", function () {
      return _this.getNumCreditBuckets() / _creditScore.ficoArray.length * 100;
    });

    _defineProperty(_assertThisInitialized(_this), "selectConstantsFromProps", function (minRange, maxRange) {
      _this.minCreditScoreIndex = (0, _creditScore.getCreditScoreBucketIndex)(minRange);
      _this.maxCreditScoreIndex = (0, _creditScore.getCreditScoreBucketIndex)(maxRange);
      _this.minCreditScoreValue = (0, _creditScore.getCreditScoreBucketValueMin)(minRange);
      _this.maxCreditScoreValue = (0, _creditScore.getCreditScoreBucketValueMax)(maxRange);
    });

    _defineProperty(_assertThisInitialized(_this), "renderApprovalRangeText", function (label) {
      var backgroundColor = _variables.colors[_this.props.backgroundColor]; // Percentage width of the bar

      var width = _this.getApprovalBarWidth(); // Left offset percent of the bar


      var left = "".concat(_this.minCreditScoreIndex / _creditScore.ficoArray.length * 100, "%");

      var color = _this.getColor();

      var labelColor = _this.props.creditScore ? LOA_COLORS.TEXT_DEFAULT : LOA_COLORS.BAR_DEFAULT;
      var backgroundBar = _variables.colors['neutral-lighter'];
      var inlineStyles = {
        color: labelColor,
        borderLeft: "2px solid ".concat(backgroundColor),
        borderRight: "2px solid ".concat(backgroundColor)
      }; // (CW-2029) the min and max credit scores overlaps when:
      // 1) the min and max credit score is 2 or less buckets apart (<=50 percentage width), and
      // 2) this loa component is in the compare page, and
      // 3) the viewport is mobile (handled in likelihood-of-approval.module.less)
      // If this is the case: add a hyphen between the 2 scores ("X-X"), and center them on the highlighted bar

      var isComparePage = _this.props.isComparePage;
      var scoresOverlap = width <= 50 && isComparePage;
      return _react.default.createElement("div", {
        className: "bar-container"
      }, _react.default.createElement("div", {
        style: _objectSpread({}, inlineStyles, {
          background: (0, _utils.default)(backgroundBar, backgroundColor, 4),
          width: '100%'
        }),
        className: (0, _classnames.default)('approval-odds-bar__background', _likelihoodOfApprovalModule.default.bar)
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(_likelihoodOfApprovalModule.default.bar, _defineProperty({}, _likelihoodOfApprovalModule.default.centerScores, scoresOverlap)),
        style: _objectSpread({}, inlineStyles, {
          width: "".concat(width, "%"),
          marginLeft: left,
          background: (0, _utils.default)(color, backgroundColor, _this.getNumCreditBuckets())
        })
      }, _react.default.createElement(_reactTypography.default, {
        className: (0, _classnames.default)('label-min', _likelihoodOfApprovalModule.default.label, _likelihoodOfApprovalModule.default.labelMin),
        inline: true
      }, _this.minCreditScoreValue), scoresOverlap && _react.default.createElement(_reactTypography.default, {
        className: (0, _classnames.default)('label-hyphen', _likelihoodOfApprovalModule.default.label, _likelihoodOfApprovalModule.default.labelHyphen),
        inline: true
      }, "-"), _react.default.createElement(_reactTypography.default, {
        className: (0, _classnames.default)('label-max', _likelihoodOfApprovalModule.default.label, _likelihoodOfApprovalModule.default.labelMax),
        inline: true
      }, _this.maxCreditScoreValue), label));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCreditScoreMarker", function () {
      var _this$props2 = _this.props,
          creditScore = _this$props2.creditScore,
          id = _this$props2.id;
      var creditScoreBucket = (0, _creditScore.getBucketFromScore)(creditScore);
      var creditScoreIndex = (0, _creditScore.getCreditScoreBucketIndex)(creditScoreBucket);
      var creditScoreMinValue = (0, _creditScore.getCreditScoreBucketValueMin)(creditScoreBucket);
      var creditScoreMaxValue = (0, _creditScore.getCreditScoreBucketValueMax)(creditScoreBucket);

      if (creditScoreBucket && creditScoreIndex > -1) {
        var elementId = "".concat(id, "__marker");

        var backgroundColor = _this.getColor();

        var creditScoreOffset = _this.calculateCreditScorePosition(creditScoreMinValue, creditScoreMaxValue, creditScoreIndex);

        var markerClasses = (0, _classnames.default)(_likelihoodOfApprovalModule.default.marker, _defineProperty({}, _likelihoodOfApprovalModule.default.markerHalfway, creditScoreIndex >= _creditScore.ficoArray.length / 2));
        var markerStyle = {
          backgroundColor: backgroundColor,
          left: creditScoreOffset
        };
        return _react.default.createElement(_reactTypography.default, {
          inline: true,
          id: elementId,
          style: markerStyle,
          className: markerClasses
        }, creditScore);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderLikelihoodOfApprovalTemplate", function (_ref) {
      var contentTop = _ref.contentTop,
          marker = _ref.marker,
          contentBottom = _ref.contentBottom;
      var _this$props3 = _this.props,
          creditScore = _this$props3.creditScore,
          layout = _this$props3.layout,
          width = _this$props3.width,
          minCreditScoreRange = _this$props3.minCreditScoreRange,
          maxCreditScoreRange = _this$props3.maxCreditScoreRange;
      var contentStyle = {
        maxWidth: layout === LAYOUT.HORIZONTAL ? width : null
      };
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('likelihood-of-approval', // legacy
        _likelihoodOfApprovalModule.default.likelihoodOfApproval, "layout".concat(layout), {
          'likelihood-of-approval--has-login-cta': !creditScore
        }, (0, _classes.default)(['display-flex', 'flex-wrap', 'flex-direction-column', // Force column layout on small viewports
        'flex-direction-row--wide', 'align-items-center--wide', {
          'justify-content-space-between--wide': layout === LAYOUT.HORIZONTAL
        }]), minCreditScoreRange, maxCreditScoreRange)
      }, contentTop && _react.default.createElement("div", {
        className: (0, _classnames.default)(_likelihoodOfApprovalModule.default.contentTop, (0, _classes.default)(['width-100'])),
        style: contentStyle
      }, contentTop, marker), contentBottom && _react.default.createElement("div", {
        className: (0, _classnames.default)(_likelihoodOfApprovalModule.default.contentBottom, (0, _classes.default)(['display-flex', 'flex-wrap', 'justify-content-space-between', 'align-items-baseline', 'width-100', 'margin-top-3', 'position-relative', {
          'width-100': layout === LAYOUT.VERTICAL,
          'width-auto--wide': layout === LAYOUT.HORIZONTAL,
          // Force TU logo to wrap
          'flex-direction-column--wide': layout === LAYOUT.HORIZONTAL,
          'align-items-center--wide': layout === LAYOUT.HORIZONTAL
        }])),
        style: contentStyle
      }, contentBottom));
    });

    _this.selectConstantsFromProps(props.minCreditScoreRange, props.maxCreditScoreRange);

    return _this;
  } // TODO: convert to React 16 lifecycle methods once all dependent apps are updated


  _createClass(LikelihoodOfApproval, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.minCreditScoreRange !== this.props.minCreditScoreRange || nextProps.maxCreditScoreRange !== this.props.maxCreditScoreRange) {
        this.selectConstantsFromProps(nextProps.minCreditScoreRange, nextProps.maxCreditScoreRange);
      }
    } // eslint-disable-next-line react/sort-comp

  }, {
    key: "renderLikelihoodOfApproval",
    value: function renderLikelihoodOfApproval() {
      // handle null case
      if (!this.props.minCreditScoreRange || !this.props.maxCreditScoreRange) {
        return false;
      }

      var _this$props4 = this.props,
          cardId = _this$props4.cardId,
          creditScore = _this$props4.creditScore,
          ctaComponent = _this$props4.ctaComponent,
          ctaText = _this$props4.ctaText,
          impressionKey = _this$props4.impressionKey,
          layout = _this$props4.layout,
          maxCreditScoreRange = _this$props4.maxCreditScoreRange,
          modelExecutionIds = _this$props4.modelExecutionIds,
          minCreditScoreRange = _this$props4.minCreditScoreRange,
          redirect_uri = _this$props4.redirect_uri,
          sectionCategory = _this$props4.sectionCategory,
          sectionPosition = _this$props4.sectionPosition,
          useTracking = _this$props4.useTracking;
      var contentTop;
      var marker = null;
      var contentBottom;
      var ctaComponentElement;
      var impressionFields = {
        id: "".concat(cardId, "-likelihood-of-approval"),
        elementDomId: Number(cardId),
        elementName: 'Likelihood of Approval',
        elementContent: ctaText,
        modelExecutionIds: modelExecutionIds,
        productId: cardId,
        productImpressionKey: impressionKey,
        sectionCategory: sectionCategory,
        sectionPosition: sectionPosition
      }; // @todo Clean this up to use common utils.

      if (creditScore) {
        marker = this.renderCreditScoreMarker();

        if (creditScore > (0, _creditScore.getCreditScoreBucketValueMax)(maxCreditScoreRange)) {
          impressionFields.elementCategory = 'ABOVE';
        } else if (creditScore >= (0, _creditScore.getCreditScoreBucketValueMin)(minCreditScoreRange)) {
          impressionFields.elementCategory = 'WITHIN';
        } else {
          impressionFields.elementCategory = 'BELOW';
        }

        contentTop = this.renderApprovalRangeText();
        contentBottom = _react.default.createElement("a", {
          href: CREDIT_DASHBOARD_PATH_WITH_TRK,
          target: "_",
          className: (0, _classes.default)('display-block')
        }, _react.default.createElement("div", {
          className: (0, _classnames.default)('tu-logo', _likelihoodOfApprovalModule.default.tuLogo)
        }), _react.default.createElement(_Right.default, {
          className: (0, _classnames.default)(_likelihoodOfApprovalModule.default.rightIcon, (0, _classes.default)([{
            'display-none': layout === LAYOUT.HORIZONTAL
          }]))
        }));
      } else {
        var interactionFields = _objectSpread({}, impressionFields, {
          type: 'CLICK'
        });

        if (ctaComponent) {
          /* supply `this.props.redirect_uri` to `ctaComponent`. This would override
          `ctaComponent.props.redirect_uri` but it is highly unlikely that the two would be
          different. Also, `redirect_uri` is on its way out as we increasingly use the auth
          modal from nwapi */
          var ctaProps = {
            redirect_uri: redirect_uri
          };

          var propsComponent = _react.default.cloneElement(ctaComponent, ctaProps);

          ctaComponentElement = _react.default.createElement("div", {
            className: _likelihoodOfApprovalModule.default.cta
          }, propsComponent);
        } else {
          var targetURI = (0, _trkHelper.setTrk)({
            url: redirect_uri,
            params: _defineProperty({}, _trkHelper.TrkTag.element, _trkHelper.TrkElement.hyperlink)
          });
          ctaComponentElement = _react.default.createElement("div", null, _react.default.createElement("div", {
            className: (0, _classnames.default)(_likelihoodOfApprovalModule.default.cta)
          }, _react.default.createElement(_reactLink.default, {
            href: targetURI
          }, _react.default.createElement(_reactTypography.default, {
            size: 1,
            uppercase: true,
            bold: true
          }, ctaText))));
        }

        if (useTracking) {
          ctaComponentElement = _react.default.createElement(CCElementInteraction, interactionFields, _react.default.createElement("div", null, ctaComponentElement));
        }

        contentTop = this.renderApprovalRangeText(this.renderLabel());
        contentBottom = redirect_uri && // eslint-disable-line
        _react.default.createElement("div", {
          className: (0, _classnames.default)([_likelihoodOfApprovalModule.default.cta, (0, _classes.default)(['width-100', {
            'width-auto--wide': layout === LAYOUT.HORIZONTAL
          }])])
        }, ctaComponentElement);
      }

      var loaComponent = this.renderLikelihoodOfApprovalTemplate({
        contentTop: contentTop,
        marker: marker,
        contentBottom: contentBottom
      });

      if (useTracking) {
        return _react.default.createElement(CCElementImpression, impressionFields, loaComponent);
      }

      return loaComponent;
    } // --- Helpers ---
    // Returns color of approval bar and labels

  }, {
    key: "getColor",
    value: function getColor() {
      return _getColor(this.minCreditScoreValue, this.maxCreditScoreValue, this.props.creditScore);
    } // Returns the css for the left offset percent of the credit score marker

  }, {
    key: "getNumCreditBuckets",
    // Returns number of credit buckets this card spans
    value: function getNumCreditBuckets() {
      return 1 + (this.maxCreditScoreIndex - this.minCreditScoreIndex);
    } // Returns percentage width for the approval bar

  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          backgroundColor = _this$props5.backgroundColor,
          fullWidth = _this$props5.fullWidth,
          headerComponent = _this$props5.headerComponent,
          omitHeading = _this$props5.omitHeading;
      return _react.default.createElement("div", {
        className: (0, _classes.default)([{
          'padding-all-3': !fullWidth
        }]),
        style: {
          backgroundColor: _variables.colors[backgroundColor]
        }
      }, !omitHeading && _react.default.createElement(_heading.default, _extends({}, this.props, {
        unstyled: !!headerComponent
      })), (0, _isNumber2.default)(this.props.approvalOdds) ? _react.default.createElement(_approvalOdds.default, this.props) : this.renderLikelihoodOfApproval());
    }
  }]);

  return LikelihoodOfApproval;
}(_react.default.Component);
/** @deprecated */


_defineProperty(LikelihoodOfApproval, "ficoArray", _creditScore.ficoArray);

_defineProperty(LikelihoodOfApproval, "colorsArray", colorsArray);

_defineProperty(LikelihoodOfApproval, "propTypes", {
  approvalOdds: _propTypes2.validateApprovalOddsProp,
  backgroundColor: _propTypes.default.oneOf(colorsArray),
  cardId: _propTypes.default.number,
  creditScore: _propTypes.default.number,
  ctaComponent: _propTypes.default.node,
  ctaText: _propTypes.default.string,
  fullWidth: _propTypes.default.bool,
  headerComponent: _propTypes.default.element,
  id: _propTypes.default.string.isRequired,
  impressionKey: _propTypes.default.string,
  isComparePage: _propTypes.default.bool,
  // eslint-disable-line react/require-default-props
  layout: _propTypes.default.oneOf([LAYOUT.HORIZONTAL, LAYOUT.VERTICAL]),
  maxCreditScoreRange: _propTypes2.validateRequiredProps,
  // eslint-disable-line react/require-default-props
  minCreditScoreRange: _propTypes2.validateRequiredProps,
  // eslint-disable-line react/require-default-props
  modelExecutionIds: _propTypes.default.arrayOf(_propTypes.default.string),
  omitHeading: _propTypes.default.bool,
  redirect_uri: _propTypes.default.string,
  sectionCategory: _propTypes.default.string,
  sectionPosition: _propTypes.default.number,
  useTracking: _propTypes.default.bool,
  width: _propTypes.default.number
});

_defineProperty(LikelihoodOfApproval, "defaultProps", {
  approvalOdds: undefined,
  backgroundColor: 'neutral-lightest',
  cardId: undefined,
  creditScore: undefined,
  ctaComponent: undefined,
  ctaText: 'Get your free credit score',
  fullWidth: false,
  headerComponent: undefined,
  impressionKey: undefined,
  isComparePage: false,
  layout: 'vertical',
  modelExecutionIds: undefined,
  omitHeading: false,
  redirect_uri: undefined,
  sectionCategory: undefined,
  sectionPosition: undefined,
  useTracking: false,
  width: undefined
});

var _default = LikelihoodOfApproval;
exports.default = _default;